<div class="list-el-container col-12 disable-li-style">
  <section class="position-absolute aca test">
    <app-card
      [enableHover]="false"
      [cursorPointer]="false"
      borderRadius="16px"
      height="94px"
      padding="24px 32px"
      [backgroundColor]="'#FFFFFF'"
    >
      <article class="d-flex align-items-center h-100" card__content>
        <section class="search-bar-row">
          <ng-content select="[left-side]"></ng-content>
          <div class="search-wrapper">
            <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            <input class="search-input"
                   name="name"
                   type="text"
                   id="name"
                   [placeholder]="'shared-components.search-bar.search-placeholder' | translate"
                   (input)="_onChangeSearch($event)">
          </div>
          <ng-content select="[right-side]"></ng-content>
        </section>
      </article>
    </app-card>
  </section>
</div>
